import { render, staticRenderFns } from "./best_sellers.vue?vue&type=template&id=f6610fea&scoped=true&"
import script from "./best_sellers.vue?vue&type=script&lang=js&"
export * from "./best_sellers.vue?vue&type=script&lang=js&"
import style0 from "./best_sellers.vue?vue&type=style&index=0&id=f6610fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6610fea",
  null
  
)

export default component.exports